import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e52759e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tp-button__container" }
const _hoisted_2 = ["disabled", "autofocus", "type"]
const _hoisted_3 = {
  key: 0,
  class: "tp-icon-loading"
}
const _hoisted_4 = {
  key: 2,
  class: "tp-button__text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "tp-button__container-blur",
      style: _normalizeStyle(`background: url(${require('@/assets/button-blur.svg')}) no-repeat center`)
    }, null, 4),
    _createElementVNode("div", {
      class: _normalizeClass(["tp-button", [
        _ctx.type ? 'tp-button--' + _ctx.type : ''
      ]]),
      disabled: _ctx.disabled,
      autofocus: _ctx.autofocus,
      type: _ctx.nativeType,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToGame()))
    }, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("i", _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.icon && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("i", {
            key: 1,
            class: _normalizeClass(_ctx.icon)
          }, null, 2))
        : _createCommentVNode("", true),
      (_ctx.$slots.default)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_2)
  ]))
}